import { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { statsGameApi } from '../statsGameApi';

const DEVICE_KEY = 'sg_device_id';

const getDeviceId = () => {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) ||
      `d-${Date.now()}-${Math.random().toString(16).slice(2, 8)}`;
    try { localStorage.setItem(DEVICE_KEY, id); } catch (_e) { /* private mode */ }
  }
  return id;
};

// Pings /presence every 30s; the owner's device toasts when a new statistician device joins.
export function useStatisticianPresence(gameId) {
  const seenRef = useRef(null);
  useEffect(() => {
    if (!gameId) return undefined;
    const deviceId = getDeviceId();

    const ping = async () => {
      try {
        const res = await statsGameApi.presence(gameId, { device_id: deviceId, device_label: 'Statistician' });
        if (!res.ok) return;
        const devices = (await res.json()).devices || [];
        if (!devices.some(d => d.is_owner && d.device_id === deviceId)) return;

        const nonOwnerIds = new Set(devices.filter(d => !d.is_owner).map(d => d.device_id));
        // First snapshot never toasts (sessions already in progress).
        if (seenRef.current === null) {
          seenRef.current = nonOwnerIds;
          return;
        }
        const prev = seenRef.current;
        const newcomers = devices.filter(d => !d.is_owner && !prev.has(d.device_id));
        if (newcomers.length > 0) {
          const count = nonOwnerIds.size;
          const label = count === 1
            ? 'A statistician joined the game'
            : `A statistician joined · ${count} statisticians online`;
          toast.success(label, { duration: 5000, id: `joined-${newcomers[0].device_id}` });
        }
        seenRef.current = nonOwnerIds;
      } catch (_e) { /* best-effort */ }
    };

    ping();
    const id = setInterval(ping, 30000);
    return () => clearInterval(id);
  }, [gameId]);
}
